import {
    actions as pageInfoActions,
} from '../common/pageInfo';
import {
    actions as bookmakersInfoActions,
    selectors as bookmakersInfoSelectors,
} from '../common/bookmakersInfo';
import {
    actions as drawerInfoActions,
} from '../drawer';
import {
    actions as betActions,
} from '../common/bet'
import { requestLogout } from '../common/loginPage/login.actions';
import formatDecimalPrice from '../common/utils/formatDecimalPrice';
import bookmakersSorting from '../common/utils/bookmakersSorting';
import {
    setRedirectLoginBookmaker,
} from '../bookmakersSwitcher/bookmakersSwitcher.actions';
import formatCourseName from '../common/utils/formatCourseName';
import PRICE_TYPES from '../common/utils/priceTypes'

const onBookmakerGet = getState => () => {
    const state = getState();
    const selectedBookmaker = bookmakersInfoSelectors.selectedBookmakerSelector(state);
    const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER', {
        detail: {
            bookmaker: selectedBookmaker,
        },
    });
    document.dispatchEvent(betslipEvent);
};

const onBookmakerSet = (getState, dispatch) => ({
    detail: {
        bookmaker,
    },
}) => {
    const state = getState();
    const {
        bookmakersList,
    } = state;
    const selectedBookmaker = bookmakersInfoSelectors.selectedBookmakerSelector(state);

    if (bookmaker !== selectedBookmaker) {
        dispatch(bookmakersInfoActions.selectBookmaker(
            bookmaker,
            bookmakersSorting,
            bookmakersList,
        ));
    }
};

const onOpenBookmakerLogin = dispatch => ({
    detail: {
        bookmaker,
    },
}) => {
    dispatch(pageInfoActions.openBookmakerSwitcherPopover());
    dispatch(setRedirectLoginBookmaker(bookmaker));
};

const onBookmakerLogout = dispatch => ({
    detail: {
        apiName,
        feed,
        isExternalLogout,
    },
}) => {
    dispatch(requestLogout(apiName, feed, isExternalLogout));
};


const onSettingsChanged = dispatch => ({
    detail: {
        useDecimalOdds,
    },
}) => {
    dispatch(pageInfoActions.setUseDecimalOdds(useDecimalOdds));
};

const onMakeSelection = (getState, dispatch) => ({
    detail,
}) => {
    const state = getState();
    const {
        bookieName,
        selectionInfo,
    } = detail;
    const {
        data,
        fractionalPrice,
        decimalPrice: decimalPriceString,
        isSp,
        id,
        eventId,
        meetingId,
        eachWayFraction,
        eachWayPlaces,
        isBog,
    } = selectionInfo;
    const {
        raceId,
        raceDate,
        horseName,
        courseName,
        time: raceTime,
    } = data;
    const decimalPrice = formatDecimalPrice(decimalPriceString);
    const formattedCourseName = formatCourseName(courseName);
    const priceType = (isSp || fractionalPrice === PRICE_TYPES.SP) ?
        PRICE_TYPES.SP :
        PRICE_TYPES.ODDS
    const bet = {
        outcomersId: id,
        fractionalPrice,
        decimalPrice,
        isSpOnly: isSp,
        eventId,
        meetingId,
        raceId,
        raceDate,
        horseName,
        courseName: formattedCourseName,
        raceTime,
        isEachWay: false,
        eachWayFraction,
        eachWayPlaces,
        isBog,
        feed: bookieName,
        stake: '',
        priceType,
        includeInMultiples: true,
    };
    const {
        isQuickslipMode,
    } = state.drawerInfo;
    const {
        selectedBets,
        selectedBookmaker,
    } = state.bookmakersInfo;

    // If bet bookie is different to selected bookie (eg odds page)
    if (bookieName !== selectedBookmaker) {
        // Set the selected bookmaker
        dispatch(bookmakersInfoActions.setSelectedBookmaker(bookieName))

        // Clear exisiting singles & multiples
        dispatch(bookmakersInfoActions.clearSelectedBets())
        dispatch(bookmakersInfoActions.clearMultiples())

        // Reset quickslip & minimized state
        dispatch(drawerInfoActions.resetEmptyBetslip())

        // Clear any placed bet details
        dispatch(betActions.clearPlacedBetDetails())

        // Reset CTA status
        dispatch(betActions.setBetObstruction(betActions.betObstructions.NONE))

        // Maximise drawer
        dispatch(drawerInfoActions.maximizeDrawer())
    }

    // Disable quickslip if it's enabled and user is adding bet 2 and above
    if (isQuickslipMode && selectedBets.length > 0) {
        dispatch(drawerInfoActions.setQuickslipMode(false))
    }

    dispatch(drawerInfoActions.setThemeFromBookieName(bookieName))
    dispatch(bookmakersInfoActions.addSelectedBet(bet))

    // Maximise when in quickslip mode
    if (isQuickslipMode) {
        dispatch(drawerInfoActions.maximizeDrawer())
    }

    const selectionMadeEvent = new CustomEvent('BETSLIP.SELECTION_MADE');
    document.dispatchEvent(selectionMadeEvent);
};

const onRemoveSelection = dispatch => ({
    detail,
}) => {
    const {
        bookieName,
        selectionInfo,
    } = detail;

    dispatch(drawerInfoActions.setThemeFromBookieName(bookieName));
    dispatch(bookmakersInfoActions.deleteBet(selectionInfo.id));

    const selectionRemovedEvent = new CustomEvent('BETSLIP.SELECTION_REMOVED');
    document.dispatchEvent(selectionRemovedEvent);
};

export default function eventsListener({
    dispatch,
    getState,
}) {
    document.addEventListener('BETSLIP.MAKE_SELECTION', onMakeSelection(getState, dispatch), false);
    document.addEventListener('BETSLIP.SETTINGS_CHANGED', onSettingsChanged(dispatch), false);
    document.addEventListener('BETSLIP.BOOKMAKER.GET', onBookmakerGet(getState), false);
    document.addEventListener('BETSLIP.BOOKMAKER.SET', onBookmakerSet(getState, dispatch), false);
    document.addEventListener('BETSLIP.BOOKMAKER.LOGIN', onOpenBookmakerLogin(dispatch), false);
    document.addEventListener('BETSLIP.BOOKMAKER.LOGOUT', onBookmakerLogout(dispatch), false);
    document.addEventListener('BETSLIP.REMOVE_SELECTION', onRemoveSelection(dispatch), false);
}



// WEBPACK FOOTER //
// /src/js/App/events.listener.js